<div *ngIf="previewImage || fileData.new"
     class="file-container">
  <div class="placeholder">{{ placeholder??'' | translate }}</div>
  <div class="preview-container" (click)="onFocus()">
    <div class="preview-file">
      <div>
<!--        Usefull to push a bit down the play icon-->
      </div>
      <img *ngIf="previewImage"
           src="{{ conf.storageRootUrl + previewImage }}"
           alt="{{ placeholder }}" />
      <mat-icon *ngIf="!previewImage"
                class="preview-file-icon">
        play_circle_outline
      </mat-icon>
      <button mat-icon-button
              class="remove-button"
              [disabled]="disabled"
              [matTooltip]="'Remove_file' | translate"
              (click)="onRemoveFileClicked($event)">
        <mat-icon color="warn">remove_circle</mat-icon>
      </button>
      <div *ngIf="!previewImage" class="preview-hint">
        {{ "Thumbnail_creation" | translate }}
      </div>
    </div>
  </div>
</div>
<div class="hidden">
  <input #fileInput
         class="file-input"
         type="file"
         tabIndex="-1"
         (change)="onFileSelectionChange($event)"
         accept="{{ '.' + allowedExtensions.join(',.') }}">
  <mat-form-field *ngIf="!fileData.current && !fileData.new"
                  [color]="color">
    <input #textInput
           matInput
           type="text"
           placeholder="{{ placeholder ?? '' | translate }}"
           [formControl]="fileFormControl"
           (click)="onFocus()"
           (keyup)="onTextChange()">
    <mat-hint *ngIf="hint" align="end">{{ hint }}</mat-hint>
    <mat-error *ngIf="fileFormControl.hasError('extension')">{{ 'Extension_error' | translate:{extension: allowedExtensions.join(', ')} }}</mat-error>
    <mat-error *ngIf="fileFormControl.hasError('size')">{{ 'Size_error' | translate:{size: maxFileSize+' Mo'} }}</mat-error>
  </mat-form-field>
</div>

<!--    custom file input -->
<div class="file-input video-input" (click)="openFileBrowser()" *ngIf="!previewImage && !fileData.new"
     (dragover)="onFileDragOver($event)" (dragleave)="onFileDragLeave($event)" (drop)="onFileDrop($event)"
     [class.dragging]="isDragging">
  <div class="preview">
    <mat-icon aria-hidden="false" aria-label="video add icon" fontIcon="video_call"></mat-icon>
    <div class="preview-text">{{ 'Add_video_drag_drop' | translate }}</div>
    <div class="hint">
      {{ hint }}
    </div>
  </div>
</div>
